import { render, staticRenderFns } from "./JudgeLi.vue?vue&type=template&id=7c81baf2&scoped=true"
import script from "./JudgeLi.vue?vue&type=script&lang=js"
export * from "./JudgeLi.vue?vue&type=script&lang=js"
import style0 from "./JudgeLi.vue?vue&type=style&index=0&id=7c81baf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81baf2",
  null
  
)

export default component.exports